import React from 'react'
import './privacypolicy.css'
import Navigation from '../../Component/Navigation/Navigation'
import Footer from '../../Component/Footer/Footer'

const sections = [
  {
    id: 'collection',
    num: '01',
    title: 'Information We Collect',
    subsections: [
      {
        heading: 'Personal Information',
        text: `We may collect personal information from you, such as your name, email address, phone number, and any other information you provide when you use our Services.`,
      },
      {
        heading: 'Usage Information',
        text: `We may collect information about how you use our Services, including your IP address, browser type, device information, and the pages you visit.`,
      },
      {
        heading: 'Financial Information',
        text: `If you request a refund or make a payment through our Services, we may collect your bank account information, credit/debit card details, and other financial information necessary to process the transaction.`,
      },
    ],
  },
  {
    id: 'use',
    num: '02',
    title: 'How We Use Your Information',
    subsections: [
      {
        heading: 'To Provide and Improve Our Services',
        text: `We use the information we collect to provide, maintain, and improve our Services, as well as to develop new features and functionality.`,
      },
      {
        heading: 'To Communicate with You',
        text: `We may use your information to respond to your inquiries, send you updates, and provide customer support.`,
      },
      {
        heading: 'To Comply with Legal Obligations',
        text: `We may use your information to comply with applicable laws, regulations, and legal processes.`,
      },
    ],
  },
  {
    id: 'sharing',
    num: '03',
    title: 'How We Share Your Information',
    subsections: [
      {
        heading: 'Service Providers',
        text: `We may share your information with third-party service providers who assist us in operating and improving our Services, such as payment processors, cloud storage providers, and analytics providers.`,
      },
      {
        heading: 'Legal Compliance',
        text: `We may share your information with law enforcement, government agencies, or other third parties as required by applicable law or to protect our rights or the rights of others.`,
      },
      {
        heading: 'Business Transfers',
        text: `In the event of a merger, acquisition, or other corporate reorganisation, we may transfer your information to the new entity.`,
      },
    ],
  },
  {
    id: 'security',
    num: '04',
    title: 'Data Security',
    subsections: [
      {
        heading: 'Security Measures',
        text: `We implement reasonable security measures to protect the confidentiality, integrity, and availability of your information. However, no method of transmission or storage is 100% secure, and we cannot guarantee the absolute security of your information.`,
      },
    ],
  },
  {
    id: 'rights',
    num: '05',
    title: 'Your Choices and Rights',
    subsections: [
      {
        heading: 'Access and Update',
        text: `You may access, review, and update your personal information by contacting us at info@nextwavesfinsedge.com.`,
      },
      {
        heading: 'Opt-Out',
        text: `You may opt-out of receiving promotional communications from us by following the unsubscribe instructions provided in the communication or by contacting us directly.`,
      },
      {
        heading: 'Data Deletion',
        text: `You may request the deletion of your personal information by contacting us, subject to certain exceptions and limitations permitted by applicable law.`,
      },
    ],
  },
  {
    id: 'changes',
    num: '06',
    title: 'Changes to this Privacy Policy',
    subsections: [
      {
        heading: 'Policy Updates',
        text: `We may update this Privacy Policy from time to time. We will post the updated policy on our website and indicate the effective date of the changes. We encourage you to review this policy periodically.`,
      },
    ],
  },
]

export default function PrivacyPolicy() {
  return (
    <div className="pp-page">
      <Navigation />

      {/* ── Header ──────────────────────────────────────────── */}
      <div className="pp-header">
        <div className="pp-header__content">
          <h1 className="pp-header__title">Privacy Policy</h1>
          <p className="pp-header__breadcrumb">Home &nbsp;/&nbsp; Privacy Policy</p>
        </div>
      </div>

      {/* ── Layout ──────────────────────────────────────────── */}
      <div className="pp-layout">

        {/* Sticky sidebar nav */}
        <aside className="pp-sidebar">
          <p className="pp-sidebar__label">On this page</p>
          <ul className="pp-sidebar__nav">
            {sections.map(s => (
              <li key={s.id}>
                <a href={`#${s.id}`}>{s.title}</a>
              </li>
            ))}
            <li><a href="#contact">Contact Us</a></li>
          </ul>
        </aside>

        {/* Main content */}
        <main className="pp-content">
          <span className="pp-badge">Effective Date: Current Version</span>

          <p className="pp-intro">
            This Privacy Policy explains how {process.env.REACT_APP_APP_NAME} ("we," "us," or "our")
            collects, uses, and discloses information about you when you use our website,
            mobile application, and other online services (collectively, the "Services").
          </p>

          {sections.map(s => (
            <section className="pp-section" id={s.id} key={s.id}>
              <div className="pp-section__head">
                <span className="pp-section__num">{s.num}</span>
                <h2>{s.title}</h2>
              </div>
              {s.subsections.map((sub, i) => (
                <div className="pp-subsection" key={i}>
                  <h3>{sub.heading}</h3>
                  <p>{sub.text}</p>
                </div>
              ))}
            </section>
          ))}

          {/* Contact card */}
          <div className="pp-contact" id="contact">
            <div className="pp-contact__text">
              <h4>Questions about this policy?</h4>
              <p>Our team is ready to help with any privacy concerns.</p>
            </div>
            <a className="pp-contact__link" href="mailto:info@nextwavesfinsedge.com">
              info@nextwavesfinsedge.com →
            </a>
          </div>
        </main>

      </div>

      <Footer />
    </div>
  )
}